<template>
  <div v-if="elementsUsable">
    <slot
      :instance="stripe"
      :elements="elements"
    />
  </div>
</template>

<script>
import {mapActions, mapState} from 'vuex'
// import {loadStripe} from '@stripe/stripe-js'

export default {
  name: 'StripeElements',
  props: {
    instanceOptions: {
      type: Object,
      default: () => ({})
    },
    elementsOptions: {
      type: Object,
      default: () => ({})
    },
    paymentIntent: {
      type: Object,
      default: () => undefined
    }
  },
  data () {
    return {
      instance: null,
      elements: {},
      clientSecret: undefined
    }
  },
  computed: {
    ...mapState('subscription', {
      stripe: state => state.stripe
    }),
    elementsUsable () {
      const elms = this.elements
      if (!elms) return false
      return Object.keys(elms).length > 0
    }
  },
  methods: {
    ...mapActions({
      initStripe: 'subscription/initStripe'
    }),
    // async initStripe () {
    //   const key = process.env.NODE_ENV === 'development'
    //     ? process.env.VUE_APP_STRIPE_KEY_DEV
    //     : process.env.VUE_APP_STRIPE_KEY
    //
    //   this.instance = await loadStripe(key)
    //   this.$emit('stripe-instance', this.instance)
    // },
    async createElements () {
      if (typeof this.stripe === 'undefined') {
        const errorMsg =
            'Instance object is not defined, make sure you initialized Stripe before creating elements'
        console.error(errorMsg)
        return errorMsg
      }

      if (this.paymentIntent) {
        const {data} = await axios.post('api/user/payment-systems/products/payment-intent', this.paymentIntent)
        this.clientSecret = data.data.client_secret
      }

      this.elements = this.stripe.elements({clientSecret: this.clientSecret, ...this.elementsOptions})
    }
  },
  async mounted () {
    await this.initStripe()

    // Create elements
    await this.createElements()
  }
}
</script>